import PatientInfoPanel from './PatientInfoPanel';

export default PatientInfoPanel;
